import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  return (
    <section id="contact" className="py-32 md:py-48 bg-brand-gray relative overflow-hidden">
      {/* Background graphic */}
      <div className="absolute right-0 top-0 opacity-[0.03] pointer-events-none transform translate-x-1/4 -translate-y-1/4">
        <span className="text-[600px] text-brand-black font-bold">♞</span>
      </div>
      
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-5xl md:text-7xl font-bold tracking-tighter mb-8 text-brand-black">
            Start the Conversation.
          </h2>
          <p className="text-2xl text-brand-muted font-light mb-12 max-w-2xl mx-auto">
            Discretion is absolute. Direct access to high-impact advisory.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16">
            <a 
              href="mailto:admin@whiteknightgc.com" 
              className="w-full sm:w-auto flex items-center justify-center gap-4 bg-brand-black text-brand-white px-10 py-5 text-lg font-bold tracking-wide hover:bg-brand-gold transition-all duration-300 shadow-xl"
            >
              <SafeIcon name="Mail" /> Email Inquiry
            </a>
            <a 
              href="https://wa.me/65988702334" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-full sm:w-auto flex items-center justify-center gap-4 bg-white border-2 border-brand-black text-brand-black px-10 py-5 text-lg font-bold tracking-wide hover:bg-brand-black hover:text-brand-white transition-all duration-300"
            >
              <SafeIcon name="MessageCircle" /> WhatsApp Secure
            </a>
            <a 
              href="tel:988702334" 
              className="w-full sm:w-auto flex items-center justify-center gap-4 bg-white border-2 border-brand-black text-brand-black px-10 py-5 text-lg font-bold tracking-wide hover:bg-brand-black hover:text-brand-white transition-all duration-300"
            >
              <SafeIcon name="Phone" /> Call Now
            </a>
          </div>

          <div className="bg-white p-8 md:p-10 border border-brand-border inline-block text-left relative shadow-lg max-w-lg w-full group hover:border-brand-gold transition-colors">
            <SafeIcon name="MapPin" className="text-brand-gold text-3xl absolute top-8 right-8 opacity-20 group-hover:opacity-100 transition-opacity" />
            <h4 className="text-sm font-bold tracking-widest uppercase text-brand-gold mb-6">Corporate Office</h4>
            <div className="space-y-4">
              <div>
                <p className="text-brand-black font-bold text-lg">Raffles Hotel Arcade</p>
                <p className="text-brand-muted">328 North Bridge Road #02-20</p>
              </div>
              <div className="pt-4 border-t border-brand-border/50">
                <p className="text-brand-muted flex items-center gap-3 mb-2">
                  <SafeIcon name="Mail" className="text-brand-gold" />
                  <a href="mailto:admin@whiteknightgc.com" className="hover:text-brand-black transition-colors">admin@whiteknightgc.com</a>
                </p>
                <p className="text-brand-muted flex items-center gap-3">
                  <SafeIcon name="Phone" className="text-brand-gold" />
                  <a href="tel:988702334" className="hover:text-brand-black transition-colors">988702334</a>
                </p>
              </div>
            </div>
          </div>

          <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-sm font-bold text-brand-muted tracking-widest uppercase">
            <span className="flex items-center gap-2"><SafeIcon name="Check" className="text-brand-gold" /> Confidential</span>
            <span className="flex items-center gap-2"><SafeIcon name="Check" className="text-brand-gold" /> Direct Access</span>
            <span className="flex items-center gap-2"><SafeIcon name="Check" className="text-brand-gold" /> Independent</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;